import { AgeRestriction, ApkInfoWithTargets } from 'client/types';

import { CommonSettings, LogoDto } from './settings';
import { BackendSettings, PublishingSettings } from './settings';
import { AliceApp, Channel } from './skill';

export enum DraftStatus {
    InDevelopment = 'inDevelopment',
    ReviewRequested = 'reviewRequested',
    ReviewCancelled = 'reviewCancelled',
    ReviewApproved = 'reviewApproved',
    ReviewRejected = 'reviewRejected',
    DeployRequested = 'deployRequested',
    DeployRejected = 'deployRejected',
    TestRequired = 'testRequired',
    MeetingApproval = 'meetingApproval',
    WaitingForTesting = 'waitingForTesting',
    AppScanRequested = 'appScanRequested',
    AppScanRequestedAfterModeration = 'appScanRequestedAfterModeration',
    DevicesTesting = 'devicesTesting',
    DevicesTestingCompleted = 'devicesTestingCompleted',
}

export interface Draft<
    TChannel extends Channel,
    BS extends BackendSettings,
    PS extends PublishingSettings,
> extends CommonSettings<BS, PS> {
    channel: TChannel;
    updatedAt: string;
    status: DraftStatus;
    isAllowedForDeploy: boolean;
    isTrustedSmartHomeSkill: boolean;
}

export interface AppDraftTrait {
    apkInfosWithTargets: ApkInfoWithTargets[];
    logoUrl: string;
    logos?: LogoDto[];
    secondaryLogoUrl?: string;
    screenshots: { imageUrl: string }[];
    ageRestriction?: AgeRestriction;
    targetPlatforms: string[];
}

export const isInDevelopment = (aliceApp: AliceApp) => {
    return aliceApp.draft.status === DraftStatus.InDevelopment;
};

export const SMART_HOME_VALIDATION_TYPES = [
    'availability',
    'user_unlink',
    'devices',
    'devices_query',
    'devices_action',
] as const;
export type SmartHomeValidationType = (typeof SMART_HOME_VALIDATION_TYPES)[number];
export type SmartHomeValidationResponse = {
    http_code: number;
    http_method: string;
    status: 'OK' | 'TIMEOUT' | 'NOT_FOUND' | 'PROVIDER_INTERNAL_ERROR' | 'SSL_CHECK_FAILED';
    url: string;
};
export type SmartHomeValidationStatuses = Record<SmartHomeValidationType, SmartHomeValidationResponse>;
